/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene, pointerToRaycaster, createTextGl, addToScene } from '../utils/forgeUtils';
import { convexHull } from '../utils/geometryUtils';
import { disposeArea2d, drawArea2d, drawPolygon, drawLine } from '../utils/threejsUtils';
import {
  ForgeEquipment,
  ForgeScaffold,
  ForgeAnnotation,
  ForgeInspection,
} from './../scripts/js/forgeModels';
import { getAMISTagById } from '@/utils/amisAPIs';
import config from '../../appConfig';
const THREE = window.THREE;
import { ShapeUtils } from './../utils/ShapeUtils';
import { isInsidePoly } from './../utils/geometryUtils';
import { $has } from '@Utils';
import permissions from '@Share/config/permissions';
import Vue from 'vue';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
import { directionToBearing } from '@/features/Dashboard/utils/compass';

class Plan2DExtension extends Autodesk.Viewing.Extension {
  constructor(loadedViewer, options) {
    super(loadedViewer, options);
    this.viewer = loadedViewer;
    this.points;
    this.directionMesh;
    this.directionMaterial;
    this.directionGeom;

    this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
    let _this = this;
    this.webGLDOM.addEventListener('click', (event) => {
      _this.onMouseUp(event);
    });
    this.viewer.canvas.addEventListener('mousedown', (event) => {
      _this.onMouseDown(event);
    });
    this.webGLDOM.addEventListener(
      'mousemove',
      (event) => {
        _this.onMouseMove(event);
      },
      false,
    );
    let isFirefox = /Firefox/i.test(navigator.userAgent);
    var mousewheelevt = isFirefox ? 'DOMMouseScroll' : 'mousewheel';
    this.viewer.canvas.addEventListener(
      mousewheelevt,
      (event) => {
        //to fix Forge issue with method setZoomInLimitFactor()
        let camera = _this.viewer.getCamera();
        if (camera.position.z > 0.02) {
          let factor = event.wheelDelta > 0 ? 1 : -1;

          let target = _this.viewer.navigation.getTarget();

          // _this.viewer.navigation.setView(new THREE.Vector3(camera.position.x, camera.position.y, camera.position.z - factor * 0.01), target, new THREE.Vector3(0, 1, 0));
        }
      },
      false,
    );
    this.sceneName = 'area-scene';
    this.measuringAreaOn = false;
    this.areaTextClass = 'floating-area-text';

    this.minAreaLineLength = 0.003;

    this.area2d = null;
    this.areaPoints = [];
    this.measuringDone = true;
    this.mouseEvent;

    this.tagToAddAreaTo = null;

    this.pinClassName = 'pinned-point-3d';
  }
  load() {
    if (store.state.forgeService.pointToZoomToIn2d) {
      store.state.forgeService.zoomToPoint2D(store.state.forgeService.pointToZoomToIn2d);
      store.state.forgeService.pointToZoomToIn2d = null;
    }
    store.state.forgeService.updateAll2DIcons();
    this.updatePinPoint();

    var _this = this;
    this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
      store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer);
      _this.updateAreaText();
      store.state.forgeService.toggleCrossHairCursorToViewer(
        !!store.state.isPickingPin || !!store.state.isPickingCmlPoint,
        this.viewer,
      );
    });

    // Set up panorama event listeners when loading the extension
    this.setupPanoramaEventListeners();

    document.addEventListener('keydown', this.onKeyDown);
    this.viewer.canvas.addEventListener('mouseup', (evt) => {
      _this.mouseEvent = { x: evt.offsetX, y: evt.offsetY };
      if (!store.state.forgeService) return;
      //focus on left click only
      if (evt.which != 1) return;

      if (store.state.isPickingCmlPoint) {
        if (!store.state.selectedLevel || !store.state.selectedLevel.hasAllMappingInfo()) {
          Vue.prototype.$dialog.notify.warning('Please finish mapping 2d/3d in admin first.');
          return;
        }
        var cmlHitTest = _this.viewer.clientToWorld(evt.offsetX, evt.offsetY, true);
        if (cmlHitTest && cmlHitTest.point) {
          let cmlWorldPt = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(cmlHitTest.point);
          cmlWorldPt.z = store.state.selectedLevel.topElevation;
          var cmlCallback = store.state.pickingCmlCallback;
          // Mirror the 3D path (forgeviewer.js:545-551) so the callback shape
          // is uniform across viewers. 2D plan picks usually have null dbId
          // (plan view is a level overlay, not the federated model), but we
          // pass through whatever clientToWorld returns to stay defensive.
          if (cmlCallback) cmlCallback({
            x: cmlWorldPt.x,
            y: cmlWorldPt.y,
            z: cmlWorldPt.z,
            dbId: cmlHitTest.dbId != null ? cmlHitTest.dbId : null,
            fragId: cmlHitTest.fragId != null ? cmlHitTest.fragId : null,
          });
          store.commit('setIsPickingCmlPoint', false);
          store.commit('setPickingCmlCallback', null);
          store.state.forgeService.toggleCrossHairCursorToViewer(false, _this.viewer);
        }
        return;
      }

      let isPickingTag = store.state.isPickingTag;
      let isPickingSubTag = store.state.isPickingSubTag;
      let isPickingPin = store.state.isPickingPin;

      if (isPickingTag || isPickingSubTag || isPickingPin) {
        if (!store.state.selectedLevel || !store.state.selectedLevel.hasAllMappingInfo()) {
          Vue.prototype.$dialog.notify.warning('Please finish mapping 2d/3d in admin first.');

          return;
        }

        var hitTest = _this.viewer.clientToWorld(evt.offsetX, evt.offsetY, true);
        if (!hitTest || !hitTest.point) return;

        let worldPt = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(hitTest.point);

        worldPt.z = store.state.selectedLevel.topElevation;

        if (isPickingTag)
          store.state.forgeService.addNewTag('2d', worldPt, store.state.selectedLevel.name, false);
        else if (isPickingSubTag) store.state.forgeService.addSubInspection(worldPt);
        else if (isPickingPin) {
          store.state.pinnedPoint2d = hitTest.point;
          this.updatePinPoint();
        }
        store.commit('setIsPickingPin', false);
        store.commit('setIsPickingTag', false);
        store.state.forgeService._isPickingAnnotation_Create = false;
      }
    });
    this.viewer.navigation.setZoomOutLimitFactor(10);

    this.viewer.registerContextMenuCallback('reality-context-menu-2d', (menu, status) => {
      const allowAdd = $has([
        permissions.Tags.Container.Create,
        permissions.Tags.Equipment.Create,
        permissions.Tags.General.Create,
        permissions.Tags.Permit.Create,
        permissions.Tags.Pipeline.Create,
        permissions.Tags.Scaffold.Create,
        permissions.Tags.Structural.Create,
        permissions.InspectionTags.Create
      ], true);

      if (!allowAdd) return;

      menu.push({
        title: 'Add Tag',
        target: () => {
          var hitTest = _this.viewer.clientToWorld(_this.mouseEvent.x, _this.mouseEvent.y, true);
          if (!hitTest || !hitTest.point) return;
          let worldPt = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(hitTest.point);
          store.state.forgeService.addNewTag('2d', worldPt, store.state.selectedLevel.name, false);
        },
      });
    });
    return true;
  }
  unload() {
    document.removeEventListener('keydown', this.onKeyDown);

    // Remove panorama event listeners on unload
    if (store.state.forgeService.panoramaViewer) {
      const panorama = store.state.forgeService.panoramaViewer;

      if (this._boundPanoramaHandlerMouseUp) {
        try {
          panorama.off('mouseup', this._boundPanoramaHandlerMouseUp);
        } catch (e) {
          debugError('Plan2DExtension', 'Error removing panorama mouseup listener during unload', e);
        }
      }

      if (this._boundPanoramaHandlerTouchEnd) {
        try {
          panorama.off('touchend', this._boundPanoramaHandlerTouchEnd);
        } catch (e) {
          debugError('Plan2DExtension', 'Error removing panorama touchend listener during unload', e);
        }
      }
    }

    return true;
  }
  onToolbarCreated() {}
  deactivate() {
    this.stopMeasuring();
    this.clearDimensions();
  }
  stopMeasuring() {
    this.measuringAreaOn = false;
    this.measuringDone = true;
  }
  clearDimensions() {
    store.state.forgeService.clearElementsByClassName(this.areaTextClass);
    this.areaPoints = [];
    disposeArea2d(this.area2d, this.viewer, this.sceneName);
    this.viewer.impl.invalidate(false, false, true);
  }
  drawDirection2D() {
    if (
      !this.viewer ||
      !this.viewer.model ||
      !store.state.selectedLevel ||
      !store.state.selectedLevel.hasAllMappingInfo()
    )
      return;

    // Initialize direction scene
    this.initDirectionScene();

    if (!store.state.selectedLevel || !store.state.selectedLevel.mappingViewersPointsInfo) return;

    // Try to get data from 3D viewer
    let viewerData = this.getDataFrom3DViewer();

    // If 3D viewer not available, try panorama viewer
    if (!viewerData.available) {
      viewerData = this.getDataFromPanoramaViewer();

      // If panorama viewer data just became available, set up event listeners
      if (viewerData.available) {
        this.setupPanoramaEventListeners();
      }
    }

    // If neither viewer has data available, return
    if (!viewerData.available) return;

    // Convert 3D position to 2D point on the plan
    const point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(viewerData.position);

    // Create direction visualization with the complete viewerData object
    this.createDirectionVisualization(point, viewerData.vector, viewerData.position, viewerData);
  }
  updatePolygonGl() {
    let color = this.isDrawingAreaToDownloadPC() ? 0x53ff53 : 0xff0000;
    disposeArea2d(this.area2d, this.viewer, this.sceneName);
    this.area2d = drawArea2d(this.areaPoints, this.viewer, this.sceneName, color);
    this.viewer.impl.invalidate(false, false, true);
    this.updateAreaText();
  }
  updateAreaText() {
    store.state.forgeService.clearElementsByClassName(this.areaTextClass);
    if (this.isPickingTagArea() || this.isDrawingAreaToDownloadPC()) return;
    if (
      store.state.selectedLevel &&
      store.state.selectedLevel.mappingViewersPointsInfo &&
      store.state.selectedLevel.mappingViewersPointsInfo.isReady() &&
      this.areaPoints.length > 0
    ) {
      let center = new THREE.Box2().setFromPoints(this.areaPoints).getCenter();
      center = new THREE.Vector3(center.x, center.y, 0);
      // let facesIndexes = ShapeUtils.triangulateShape(this.areaPoints,[]);
      let globalPoints = this.areaPoints.map((o) =>
        store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o),
      );
      let area = ShapeUtils.area(globalPoints).toFixed(2);
      if (area < 0) area *= -1;
      var unit =
        !store.state.viewer || !store.state.viewer.model
          ? 'm²'
          : store.state.viewer.model.getDisplayUnit() + '²';
      area = area + ' ' + unit;

      let container = this.viewer.container;
      if (!container) return;

      let label = document.createElement('div');
      label.setAttribute('data-x', center.x);
      label.setAttribute('data-y', center.y);
      label.setAttribute('data-z', 0);
      label.className = this.areaTextClass;

      let textSpan = document.createElement('span');
      textSpan.textContent = area;
      label.appendChild(textSpan);

      label.style.position = 'absolute';
      label.style.background = 'rgba(29, 199, 243, 0.85)';
      label.style.color = '#ffffff';
      label.style.fontSize = '13px';
      label.style.fontWeight = '600';
      label.style.padding = '4px 10px';
      label.style.borderRadius = '10px';
      label.style.pointerEvents = 'none';
      label.style.whiteSpace = 'nowrap';
      label.style.zIndex = '1';

      container.appendChild(label);
      void label.offsetWidth;
      store.state.forgeService.updateLabelsPositionsByClassName(this.areaTextClass, this.viewer);
    }
  }
  updatePinPoint() {
    var point = store.state.pinnedPoint2d;
    store.state.forgeService.clearElementsByClassName(this.pinClassName);
    if (point) {
      var iconOptions = {
        position: point,
        differences: null,
        title: '',
        id: '',
        className: this.pinClassName,
        forgeViewer: this.viewer,
        onClick: () => {},
        addContent: false,
      };
      store.state.forgeService.create3DIconToViewer(iconOptions);
      store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer);
    }
    store.state.forgeService.toggleCrossHairCursorToViewer(false, this.viewer);
    this.viewer.impl.invalidate(true, true, true);
  }
  closeAreaPoints() {
    if (!this.measuringDone && this.areaPoints.length > 3) {
      this.measuringDone = true;
      this.measuringAreaOn = false;
      this.areaPoints[this.areaPoints.length - 1] = this.areaPoints[0];
      this.updatePolygonGl();
      store.commit('SET_IS_MEASURING_AREA', false);
    }
  }
  toggleMeasuringArea(measureOn) {
    store.commit('SET_IS_MEASURING_AREA', measureOn);
    this.measuringAreaOn = measureOn;
    this.areaPoints = [];
    if (measureOn) {
      store.state.forgeService?.restoreViewerCursor(this.viewer);
    } else {
      this.deactivate();
      store.state.forgeService?.restoreViewerCursor(this.viewer);
    }
  }
  setTagToAddAreaTo(tag) {
    this.tagToAddAreaTo = tag;
    this.toggleMeasuringArea(true);
  }
  setDrawingMode(drawingOn) {
    this.measuringAreaOn = drawingOn;
    this.areaPoints = [];
    if (!drawingOn) this.deactivate();
  }
  isPickingTagArea() {
    return (
      this.tagToAddAreaTo &&
      (store.getters['GET_ADDING_TAG_INFO'] ||
        store.getters['GET_EDITING_AMIS_TAG'] ||
        store.getters['GET_EDITING_TAG'])
    );
  }
  isDrawingAreaToDownloadPC() {
    return store.getters['getIsDrawingAreaToDownloadPC'];
  }
  addAreaToTag() {
    let worldPoints = this.areaPoints.map((o) =>
      store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o),
    );
    let tagPoint = this.tagToAddAreaTo.getGlobalPoint();
    if (isInsidePoly(tagPoint, worldPoints)) this.tagToAddAreaTo.area2dPoints = worldPoints;
    else Vue.prototype.$dialog.notify.warning('Area does not contain tag point.');

    this.tagToAddAreaTo = null;
    this.deactivate();
    store.state.forgeService.updateAll2DIcons();
  }
  processDownloadPC() {
    let worldPoints = this.areaPoints.map((o) =>
      store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o),
    );
    store.state.forgeService.sendDataToDownloadPointCloudTab(worldPoints);
  }
  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      if (this.measuringAreaOn) {
        this.closeAreaPoints();
        if (this.isPickingTagArea()) this.addAreaToTag();
        else if (this.isDrawingAreaToDownloadPC()) this.processDownloadPC();
      }
    } else if (event.keyCode === 27) {
      this.deactivate();
      store.commit('SET_IS_MEASURING_AREA', false);
    }
  };
  onMouseMove(mouse) {
    if (!this.measuringAreaOn || !this.viewer.impl) return;
    if (!this.dragged) {
      this.dragged = true;
      return;
    }
    let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
    if (!mouseWorld) return;
    mouseWorld = mouseWorld.point;
    if (!this.measuringDone && this.areaPoints.length > 0) {
      if (this.areaPoints[0].distanceTo(mouseWorld) < this.minAreaLineLength)
        this.areaPoints[this.areaPoints.length - 1] = this.areaPoints[0];
      else this.areaPoints[this.areaPoints.length - 1] = mouseWorld;
      this.updatePolygonGl();
    }
  }
  onMouseDown(mouse) {
    if (mouse.which != 1) return;
    this.dragged = false;
  }
  onMouseUp(mouse) {
    if (mouse.which != 1 || !this.measuringAreaOn) return;
    if (this.dragged) return;
    let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
    if (!mouseWorld) return;
    mouseWorld = mouseWorld.point;

    if (!this.measuringDone) {
      if (this.areaPoints[0].distanceTo(mouseWorld) < this.minAreaLineLength) {
        this.measuringDone = true;
        this.measuringAreaOn = false;
        store.commit('SET_IS_MEASURING_AREA', false);

        if (this.isPickingTagArea()) this.addAreaToTag();
        else if (this.isDrawingAreaToDownloadPC()) this.processDownloadPC();
      } else this.areaPoints.push(mouseWorld);
    } else {
      this.areaPoints = [mouseWorld, mouseWorld.clone()];
      this.measuringDone = false;
    }
    this.updatePolygonGl();
  }

  // Initialize direction scene
  initDirectionScene() {
    if (!this.viewer.overlays.hasScene('direction2D-scene')) {
      this.viewer.overlays.addScene('direction2D-scene');
    }
    if (this.directionMesh) {
      this.directionGeom.dispose();
      this.directionMaterial.dispose();
      this.viewer.overlays.removeMesh(this.directionMesh, 'direction2D-scene');
    }
  }

  // Get vector and position from 3D viewer
  getDataFrom3DViewer() {
    if (store.state.viewer && store.state.unitScale) {
      return {
        vector: store.state.viewer.navigation.getCamera().getWorldDirection(),
        position: store.state.forgeService.view3dToWorld(
          store.state.viewer.navigation.getPosition(),
        ),
        available: true
      };
    }
    return { available: false };
  }

  // Get vector and position from panorama viewer
  getDataFromPanoramaViewer() {
    if (!store.state.forgeService.panoramaViewer || !store.state.selectedImage) {
      return { available: false };
    }

    // Position must be in world meters to match what _3dTo2d expects
    // (the 3D adapter produces world meters via view3dToWorld).
    const position = store.state.selectedImage.getCameraWorldPosition();
    if (!position) {
      return { available: false };
    }

    const panorama = store.state.forgeService.panoramaViewer;

    // Convert panorama yaw/pitch to a compass bearing in the Forge XY plane.
    // lockBearing is the compass bearing of the locked direction (was hardcoded
    // to -90 / 270° West, now derived from the actual lockedForgeDirection).
    const lockBearing = directionToBearing(store.state.selectedImage.lockedForgeDirection);
    let angle = panorama.getYaw() - store.state.selectedImage.lockedYaw + lockBearing;
    // Normalize to [-180, 180) — use modulo instead of single if/else because
    // lockBearing can be up to 360° and push the sum well beyond ±180.
    angle = ((angle % 360) + 360) % 360; // → [0, 360)
    if (angle > 180) angle -= 360;       // → [-180, 180)

    const yaw = (angle) * Math.PI / 180; // Convert to radians
    const pitch = panorama.getPitch() * Math.PI / 180; // Convert to radians

    // Create direction vector from spherical coordinates
    const vector = new THREE.Vector3(
      Math.cos(pitch) * Math.sin(yaw),
      Math.cos(pitch) * Math.cos(yaw),
      Math.sin(pitch)
    );

    return {
      vector,
      position,
      available: true,
      // Add FOV to data so we can use it in the visualization
      fov: panorama.getHfov(),
    };
  }

  // Create direction visualization
  createDirectionVisualization(point, vector, position, viewerData) {
    // Calculate scale factor based on FOV if available (for panorama viewer)
    let scaleFactor = 0.05; // Default scale factor
    let baseOpacity = 0.5;  // Default opacity
    let arrowWidth = 1.0;   // Default arrow width ratio

    if (viewerData && viewerData.fov) {
      // Get FOV bounds from panorama viewer
      const panorama = store.state.forgeService.panoramaViewer;
      const bounds = panorama.getHfovBounds();
      const minFOV = bounds[0];
      const maxFOV = bounds[1];
      const currentFOV = viewerData.fov;

      // Calculate normalized zoom level (0 = fully zoomed in, 1 = fully zoomed out)
      const zoomLevel = (currentFOV - minFOV) / (maxFOV - minFOV);

      // Adjust scale factor inversely to zoom level
      // When zoomed in (small FOV), we want a narrower FOV cone representation
      const minScale = 0.03;
      const maxScale = 0.08;
      scaleFactor = minScale + (maxScale - minScale) * zoomLevel;

      // Adjust opacity based on zoom - more transparent when zoomed out
      baseOpacity = 0.4 + (0.6 - 0.4) * (1 - zoomLevel);

      // Adjust arrow width - narrower when zoomed in (representing narrower field of view)
      // This affects how wide the arrow head is
      arrowWidth = 0.7 + 0.6 * zoomLevel;

      // Clamp to reasonable limits
      scaleFactor = Math.max(minScale, Math.min(maxScale, scaleFactor));
      baseOpacity = Math.max(0.3, Math.min(0.7, baseOpacity));
      arrowWidth = Math.max(0.5, Math.min(1.3, arrowWidth));
    }

    // Normalize and scale vector for visualization
    vector = vector.normalize().multiplyScalar(scaleFactor);

    // Calculate points for arrow shape - using arrowWidth to adjust width
    const normalVec = new THREE.Vector2(-vector.y, vector.x);
    const pt1 = point.clone().add(vector).add(normalVec.multiplyScalar(arrowWidth));
    const pt2 = point.clone().add(vector).add(normalVec.clone().negate().multiplyScalar(arrowWidth));
    const bz1 = pt1.clone().add(vector);
    const bz2 = pt2.clone().add(vector);

    // Create arrow shape
    const heartShape = new THREE.Shape();
    heartShape.moveTo(pt1.x, pt1.y);
    heartShape.moveTo(point.x, point.y);
    heartShape.moveTo(pt2.x, pt2.y);
    heartShape.bezierCurveTo(bz2.x, bz2.y, bz1.x, bz1.y, pt1.x, pt1.y);

    // Create geometry and material
    this.directionGeom = new THREE.ShapeGeometry(heartShape);
    const color = store.state.selectedLevel.containsElevation(position.z) ? 0x6fcd3b : 0x8ccecd;
    this.directionMaterial = new THREE.MeshBasicMaterial({
      color: color,
      opacity: baseOpacity,
      transparent: true,
    });

    // Create and position mesh
    this.directionMesh = new THREE.Mesh(this.directionGeom, this.directionMaterial);
    this.directionMesh.position.setZ(0.01);

    // Add to viewer and update
    this.viewer.overlays.addMesh(this.directionMesh, 'direction2D-scene');
    this.viewer.impl.invalidate(true, true, true);
  }

  panoramaEventHandler() {
    debugLog('Plan2DExtension', 'Panorama event handler');
    if (store.state.selectedImage) {
      this.drawDirection2D();
    }
  }

  // Set up panorama viewer event listeners
  setupPanoramaEventListeners() {
    if (store.state.forgeService.panoramaViewer) {
      const panorama = store.state.forgeService.panoramaViewer;
      const _this = this; // Store reference to 'this'

      // Remove existing listeners if they exist
      if (this._boundPanoramaHandlerMouseUp) {
        try {
          panorama.off('mouseup', this._boundPanoramaHandlerMouseUp);
        } catch (e) {
          debugError('Plan2DExtension', 'Error removing panorama mouseup listener', e);
        }
      }

      if (this._boundPanoramaHandlerTouchEnd) {
        try {
          panorama.off('touchend', this._boundPanoramaHandlerTouchEnd);
        } catch (e) {
          debugError('Plan2DExtension', 'Error removing panorama touchend listener', e);
        }
      }

      if (this._boundPanoramaHandlerZoomChange) {
        try {
          panorama.off('zoomchange', this._boundPanoramaHandlerZoomChange);
        } catch (e) {
          debugError('Plan2DExtension', 'Error removing panorama zoomchange listener', e);
        }
      }

      // Create new handlers with proper this binding
      this._boundPanoramaHandlerMouseUp = function() {
        if (store.state.selectedImage) {
          _this.drawDirection2D();
        }
      };

      this._boundPanoramaHandlerTouchEnd = function() {
        if (store.state.selectedImage) {
          _this.drawDirection2D();
        }
      };

      this._boundPanoramaHandlerZoomChange = function() {
        if (store.state.selectedImage) {
          _this.drawDirection2D();
        }
      };

      // Add event listeners for panorama movement
      try {
        panorama.on('mouseup', this._boundPanoramaHandlerMouseUp);
        panorama.on('touchend', this._boundPanoramaHandlerTouchEnd);
        panorama.on('zoomchange', this._boundPanoramaHandlerZoomChange);
      } catch (e) {
        debugError('Plan2DExtension', 'Error adding panorama event listeners', e);
      }
    }
  }
}
Autodesk.Viewing.theExtensionManager.registerExtension('Plan2DExtension', Plan2DExtension);
